import styled from 'styled-components';

export const TextArea = styled.textarea`
	width: 100%;
	height: 96px;
	padding: 12px;
	box-sizing: border-box;
	color: ${({ theme }) => theme['font-primary']};
	caret-color: ${({ theme }) => theme['orange-primary']};

	font-family: 'Pretendard';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;

	border-radius: 6px;
	border: 1px solid ${({ theme }) => theme['warmgray-200']};
	background: ${({ theme }) => theme['white-primary']};
	resize: none;

	&::placeholder {
		color: ${({ theme }) => theme['font-tertiary']};
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		font-family: 'Pretendard';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: 0.5px;
	}
`;

export const TextAreaCounter = styled.div`
	position: absolute;
	right: 20px;
	bottom: 10px;
`;
